//import React from 'react';

import React from 'react';
import {useSelector} from 'react-redux' 
import Sidebar from '../Sidebar/Sidebar'; 
import ProfileIcon from '../../../assets/images/profile.png'
const  Profiles = () => { 
    const {loggedInUser} = useSelector((state:any) => state.auth) 

 
  return (
	<div className="page-content bg-light">
		<div className="dz-bnr-inr bg-secondary overlay-black-light bannerBG">
		<div className="container">
			<div className="dz-bnr-inr-entry">
			<h1>My Account</h1>
			<nav aria-label="breadcrumb" className="breadcrumb-row">
				<ul className="breadcrumb">
				<li className="breadcrumb-item"><span> Home</span></li>

				<li className="breadcrumb-item"> Profile</li>
				</ul>
			</nav>
			</div>
		</div>	
		</div> 
	
        <div className="content-inner-1">
			<div className="container">
                <div className="row">
                    <Sidebar  selectedLink={"My Profile"}/>
                    {loggedInUser !== null &&
                    <section className="col-xl-9 account-wrapper">
                    <div className="account-card">
                        <div className="profile-edit">
                            <div className="avatar-upload d-flex align-items-center">
                                <div className=" position-relative ">
                                    <div className="avatar-preview thumb">
                                        <div id="imagePreview" ><img src={ProfileIcon} alt="profile"></img></div>
                                    </div> 
                                </div>
                            </div>
                            <div className="clearfix">
                                <h2 className="title mb-0">{loggedInUser.name}</h2><span className="text text-primary">{loggedInUser.email}</span>
                                
                            </div>
                        </div>
                        <form action="#" className="row">
                            <div className="col-lg-6">
                                <div className="form-group m-b25">
                                    <label className="label-title">Name</label>
                                    
                                    <input name="dzName" defaultValue={loggedInUser.name}  className="form-control"/>
                                </div>
                            </div>
                            
                            <div className="col-lg-6">
                                <div className="form-group m-b25">
                                    <label className="label-title">Email address</label>
                                    <input type="email" name="dzEmail"  defaultValue={loggedInUser.email} className="form-control"/>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-group m-b25">
                                    <label className="label-title">Mobile</label>
                                    <input type="email" name="dzPhone"  defaultValue={loggedInUser.mobile} className="form-control"/>
                                </div>
                            </div>
                            
                        </form> 
                    </div>
                </section>
                    }
					
                    {/* <section className="col-xl-9 account-wrapper">
						<div className="account-card">
							<div className="profile-edit">
								<div className="avatar-upload d-flex align-items-center">
									<div className=" position-relative ">
										<div className="avatar-preview thumb">
											<div id="imagePreview" ></div>
										</div> 
									</div>
								</div>
								<div className="clearfix">
									<h2 className="title mb-0">{loggedInUser.name}</h2><span className="text text-primary">{loggedInUser.email}</span>
									
								</div>
							</div>
							<form action="#" className="row">
								<div className="col-lg-6">
									<div className="form-group m-b25">
										<label className="label-title">First Name</label>
										<input name="dzName"  className="form-control"/>
									</div>
								</div>
								<div className="col-lg-6">
									<div className="form-group m-b25">
										<label className="label-title">Last Name</label>
										<input name="dzName"  className="form-control"/>
									</div>
								</div>
								<div className="col-lg-6">
									<div className="form-group m-b25">
										<label className="label-title">Email address</label>
										<input type="email" name="dzEmail"  className="form-control"/>
									</div>
								</div>
								<div className="col-lg-6">
									<div className="form-group m-b25">
										<label className="label-title">Phone</label>
										<input type="email" name="dzPhone"  className="form-control"/>
									</div>
								</div>
								<div className="col-lg-6">
									<div className="form-group m-b25">
										<label className="label-title">New password (leave blank to leave unchanged)</label>
										<input type="password" name="password"  className="form-control"/>
									</div>
								</div>
								<div className="col-lg-6">
									<div className="form-group m-b25">
										<label className="label-title">Confirm new password</label>
										<input type="password" name="password"  className="form-control"/>
									</div>
								</div>
							</form>
							<div className="d-flex flex-wrap justify-content-between align-items-center">
								<div className="form-group">
									<div className="custom-control custom-checkbox text-black">
										<input type="checkbox" className="form-check-input" id="basic_checkbox_1"/>
										<label className="form-check-label" >Subscribe me to Newsletter</label>
									</div>
								</div>
								<button className="btn btn-primary mt-3 mt-sm-0" type="button">Update profile</button>
							</div>
						</div>
					</section> */}
				</div>
      		</div>
		</div>
	</div>
  );
}

export default Profiles;

 
